import React from "react";

function CreatePsaBtn({ accountSlug, projectId, className }) {
  return (
    <button
      type="button"
      className={`btn btn-success createPsaBtn ${className}`}
      onClick={() => window.location.assign(`/projects/${projectId}/psa_project/new`)}
    >
      <i className="fa fa-share-square"></i> Push to PSA Project
    </button>
  );
}

export default CreatePsaBtn;
